import { render, staticRenderFns } from "./CaseEdit.vue?vue&type=template&id=7228e065&scoped=true&lang=pug&"
import script from "./CaseEdit.vue?vue&type=script&lang=js&"
export * from "./CaseEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7228e065",
  null
  
)

export default component.exports